import { useState } from "react";
import { ReactComponent as WidgetDark } from "@/assets/images/config/widget-dark.svg";
import { ReactComponent as WidgetLight } from "@/assets/images/config/widget-light.svg";
import { Button, Panel, Typography } from "@/components/atoms";
import { useOperator } from "@/hooks";
import { RequirePermission } from "@/permissions/RequirePermission";
import { EPermission } from "@/permissions/types";
import { clsx } from "@/utils";
import { WidgetModal } from "./WidgetModal";
import { WidgetType } from "./type";

export const WidgetsPanel = () => {
  const { id } = useOperator();
  const [type, setType] = useState<WidgetType>("default");
  const [showModal, setShowModal] = useState(false);
  const optionClassName =
    "flex flex-col items-center justify-center py-4 px-[19px] gap-y-2.5 rounded-lg border border-neutral-mid-gray bg-white cursor-pointer hover:text-primary hover:bg-primary-light";

  return (
    <RequirePermission permission={EPermission.InstantQuoteView}>
      <div className="flex w-full flex-col gap-5 lg:flex-row">
        <div className="flex-1">
          <Panel className="flex flex-col">
            <div className="flex flex-col gap-y-1">
              <Typography variant="h3">Widgets</Typography>
              <Typography variant="paragraph" className="text-neutral-dark-gray">
                Embed a quotation widget on your website, choose from the options below.
              </Typography>
            </div>
            <div className="mt-8 flex flex-row gap-5">
              <div className="flex flex-col gap-y-2.5">
                <Typography variant="action">Option 1</Typography>
                <div
                  className={clsx(optionClassName, { "border-primary bg-primary-light text-primary": type === "default" })}
                  onClick={() => setType("default")}
                >
                  <WidgetLight />
                  <Typography variant="action">Default Widget</Typography>
                </div>
              </div>
              <div className="flex flex-col gap-y-2.5">
                <Typography variant="action">Option 2</Typography>
                <div
                  className={clsx(optionClassName, { "border-primary bg-primary-light text-primary": type === "branded" })}
                  onClick={() => setType("branded")}
                >
                  <WidgetDark />
                  <Typography variant="action">Branded Widget</Typography>
                </div>
              </div>
            </div>
          </Panel>
        </div>
        <div className="flex">
          <Panel className="flex w-full flex-col items-center lg:w-[615px]">
            <Typography variant="title" className="text-neutral-dark-gray">
              Widget Preview
            </Typography>
            <iframe
              className="mt-8 h-[600px] w-full max-w-[400px]"
              title="Get an instance quote"
              src={`https://widgets.rideminder.com/instant-quote/?provider=${id}${type === "branded" ? "&use_branding=1" : ""}`}
            />
            <Button variant="primary" size="lg" onClick={() => setShowModal(true)} className="mt-10">
              Get the HTML Code
            </Button>
          </Panel>
        </div>
        <WidgetModal open={showModal} onClose={() => setShowModal(false)} type={type} />
      </div>
    </RequirePermission>
  );
};
